import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const Confirm = ({ confirmData, confirmDataHandle, updateId }) => {
    const tipText = updateId ? '確認更新報名資料嗎？' : '確認提交報名資料嗎？';
    
    return !confirmData.isClosePopup ? (
        <div className={styles.confirm}>
            <div className={styles.confirmBox}>
                <div className={styles.confirmTitle}>{tipText}</div>
                <div className={styles.confirmOperate}>
                    <div
                        className={styles.confirmYes}
                        onClick={() => {
                            confirmDataHandle({ isClickOk: true, isCheck: false, isClosePopup: true });
                        }}>
                        確認
                    </div>
                    <div
                        className={styles.confirmCancel}
                        onClick={() => {
                            confirmDataHandle({ isClickOk: false, isCheck: true, isClosePopup: true });
                        }}>
                        再檢查一下
                    </div>
                </div>
            </div>
        </div>
    ) : null;
};

Confirm.propTypes = {
    confirmData: PropTypes.object,
    confirmDataHandle: PropTypes.func,
    updateId: PropTypes.string
};

export default errorBoundary(Confirm);
